module.exports = __webpack_public_path__ + "static/media/learner_welcome_email_preview.b49acbea.png";